/* MIS Industrial — rfq-prefill.js (RFQ / Sell Surplus pages only)
   Prefills the fallback form from query params set by product/cart/search
   links (?ref, ?mpn, ?sku, ?purl, ?q, ?lines) and guards against duplicate
   submits. Without JS the form still works — buyers type details manually. */

const params = new URLSearchParams(window.location.search);

const ref = params.get('ref') || '';
const mpn = params.get('mpn') || '';
const sku = params.get('sku') || '';
const purl = params.get('purl') || '';
const q = params.get('q') || '';
const lines = params.get('lines') || '';

const set = (selector, value) => {
  const el = document.querySelector(selector);
  if (el && value) el.value = value;
};

set('[data-rfq-hidden-ref]', ref);
set('[data-rfq-hidden-mpn]', mpn);
set('[data-rfq-hidden-sku]', sku);
set('[data-rfq-hidden-url]', purl);

const linesField = document.querySelector('[data-rfq-lines]');
if (linesField && !linesField.value) {
  if (lines) linesField.value = lines;
  else if (mpn || q || ref) linesField.value = [mpn || q || ref, (mpn || q) && ref ? `(ref: ${ref})` : ''].filter(Boolean).join(' ');
}

const context = document.querySelector('[data-rfq-context]');
if (context && (mpn || sku || ref)) {
  context.querySelector('[data-rfq-context-text]').textContent = [mpn, sku, ref].filter(Boolean).join(' · ');
  context.hidden = false;
}

/* Duplicate-submit guard for all single-submit forms on the page. */
document.querySelectorAll('[data-single-submit]').forEach((button) => {
  const form = button.closest('form');
  if (!form) return;
  form.addEventListener('submit', (event) => {
    if (button.dataset.submitted) {
      event.preventDefault();
      return;
    }
    button.dataset.submitted = 'true';
    window.setTimeout(() => {
      button.disabled = true;
      if (button.dataset.sendingLabel) button.textContent = button.dataset.sendingLabel;
    }, 0);
  });
});
